const translations = {
	status: {
		declined: "Un signataire a refusé de signer",
		expired: "Le délai de signature a expiré",
		processing: "En cours de traitement",
		waiting_signature: "En cours de signature",
		waiting_transfer_sg: "À transmettre à la société de gestion",
		waiting_validation: "En attente de validation",
		// Private equity dont la société de gestion signe le contrat : le dossier transmis attend sa signature.
		waiting_management_company_signature: "En attente de la signature de la société de gestion",
		validated: "Validé",
	},
	follow_up: "Suivi du dossier",
};

export default translations;
